import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import { fetchContentsAction } from './ContentWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const planWS = (state = { plans: [], plan: {} }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.PLAN.SET_PLANS:
      return Object.assign({}, state, { plans: action.datas })
    case Constants.ActionsConstants.PLAN.SET_PLAN:
      return Object.assign({}, state, { plan: action.datas })
    default:
      return state
  }
}

export const set = (data) => {
  return {
    type: Constants.ActionsConstants.PLAN.SET_PLANS,
    datas: data,
  }
}

export const setPlan = (data) => {
  return {
    type: Constants.ActionsConstants.PLAN.SET_PLAN,
    datas: data,
  }
}

export function plansCalls (dispatch, sectionid, planid, plan, section) {
  function fetchPlan () {
    let method = Constants.UrlsConstants.planEntryPoint+Constants.MethodsWSConstants.PLAN.GET_DETAIL+planid

    fetch(urlServer+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setPlan(data))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function addPlan () {
    let method = Constants.UrlsConstants.planEntryPoint+Constants.MethodsWSConstants.PLAN.SET+sectionid

    fetch(urlServer+method, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(plan),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setPlan(data))
        fetchContentsAction(dispatch, null, null, null, section, null).fetchSection()
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function updatePlan () {
    let method = Constants.UrlsConstants.planEntryPoint+Constants.MethodsWSConstants.PLAN.UPDATE

    fetch(urlServer+method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(plan),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setPlan(data))
        fetchContentsAction(dispatch, null, null, null, section, null).fetchSection()
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deletePlan () {
    let method = Constants.UrlsConstants.planEntryPoint+Constants.MethodsWSConstants.PLAN.DELETE+planid

    fetch(urlServer+method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      // .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        dispatch(setPlan({}))
        fetchContentsAction(dispatch, null, null, null, section, null).fetchSection()
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    fetchPlan,
    addPlan,
    updatePlan,
    deletePlan,
  }
}
